// @flow
import { getConfEnvName, ENVS } from "@cld/env-config";

const isDev = () => (getConfEnvName() === ENVS.DEVELOPMENT);

const throwOnDev = (...args: any[]) => {
	if (process.env.NODE_ENV !== "production") { // avoid rollbar errors in production
		throw ((args[0] instanceof Error) ? args[0] : new Error(...args));
	}
};

export {
	isDev,
	throwOnDev,
};
